import {
  assignIfExists,
  findMatch,
  findResultByEvent,
  mapResults,
  removeItemByCodeAndEvent,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { activeNotification, newNotificationsList, notificationsResult } from './state';

const fetchNotifications = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.notifications[action.category].results.push({
      ...newNotificationsList(action.code, action.event),
      readStatus: states.PENDING,
    });
  }
});

const showNotifications = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = action.append
    ? mapResults(item.results, action, notificationsResult)
    : mapResults([], action, notificationsResult);
  item.name = action.name;
  item.pageSize = action.pageSize;
  item.count = action.resultsCount;
  item.currentPage = action.currentPage;
  item.totalPages = action.totalPages;
});

const showNotificationsError = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const updateNotificationsFilter = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  item.filter = action.value;
});

const showNotification = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  const notification = findMatch(item.results, action.notificationCode);
  draft.activeNotification.open = true;
  draft.activeNotification.category = action.category;
  draft.activeNotification.code = action.code;
  draft.activeNotification.event = action.event;
  draft.activeNotification.notification = notification;
});

const hideNotification = withDraft((draft) => { draft.activeNotification = activeNotification(); });

const closeNotifications = withDraft((draft, action) => {
  const item = findResultByEvent(draft.notifications, action, action.event);
  if (item?.code && item.event) {
    draft.notifications[action.category].results = removeItemByCodeAndEvent(
      draft.notifications[action.category].results,
      item,
    );
  } else if (item) {
    assignIfExists(item, newNotificationsList(null, null));
  }
});

export default {
  [actions.CLOSE_NOTIFICATIONS]: closeNotifications,
  [actions.FETCH_NOTIFICATIONS]: fetchNotifications,
  [actions.HIDE_NOTIFICATION]: hideNotification,
  [actions.REFRESH_NOTIFICATIONS]: fetchNotifications,
  [actions.SHOW_NOTIFICATION]: showNotification,
  [actions.SHOW_NOTIFICATIONS]: showNotifications,
  [actions.SHOW_NOTIFICATIONS_ERROR]: showNotificationsError,
  [actions.UPDATE_NOTIFICATIONS_FILTER]: updateNotificationsFilter,
};
